export const extractYoutubeVideoId = (url: string): string => {
  const match = url.match(/shorts\/([a-zA-Z0-9_-]+)/);
  return match ? match[1] : '';
};

export const getYoutubeEmbedUrl = (url: string): string => {
  const videoId = extractYoutubeVideoId(url);
  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
};

export enum EThumbnailQuality {
  LOW = 'low',
  DEFAULT = 'default',
  MEDIUM = 'medium',
  HIGH = 'high',
  MAX = 'max',
  SHORTS = 'shorts',
}

interface getYoutubeThumbnailUrlProps {
  videoId: string;
  quality?: EThumbnailQuality;
}

export const getYoutubeThumbnailUrl = ({
  videoId,
  quality = EThumbnailQuality.DEFAULT,
}: getYoutubeThumbnailUrlProps): string => {
  if (!videoId) return '';

  const qualityMap: Record<EThumbnailQuality, string> = {
    [EThumbnailQuality.LOW]: 'default',
    [EThumbnailQuality.DEFAULT]: 'mqdefault',
    [EThumbnailQuality.MEDIUM]: 'hqdefault',
    [EThumbnailQuality.HIGH]: 'sddefault',
    [EThumbnailQuality.MAX]: 'maxresdefault',
    [EThumbnailQuality.SHORTS]: 'oardefault',
  };

  return `https://img.youtube.com/vi/${videoId}/${qualityMap[quality]}.jpg`;
};
